<template>
  <v-list
    :content="toList"
    :titles="titles"
    columnsWidth="200"
    :darkModeOn="false"
    inputPlaceholder="Seach something..."
    :tableHeight="300"
  />
</template>

<script>
import VList from "vue-js-list";
export default {
  name: "App",
  setup() {
    let toList = [
      ["content1", "content2", "content3"],
      ["content4", "content5", "content6"],
      ["content7", "content8", "content9"],
      ["content10", "content11", "content12"],
      ["content13", "content14", "content15"],
      ["content16", "content17", "content18"],
    ];

    let titles = ["title1", "title2", "title3"];
    return { toList, titles };
  },
  components: {
    VList,
  },
};
</script>

<style>
#app {
  background: #394ded;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

html,
body {
  height: 100vh;
  margin: 0;
}
</style>
